<div class="roadtax-blacklisted-dialog">
  <div class="roadtax-blacklisted-dialog__content">
    <div class="roadtax-blacklisted-dialog__icon">
      <img src="https://storage.googleapis.com/ps-asset/motor/dialog/warn-red-logo.png" alt="Warning" />
    </div>

    <div class="roadtax-blacklisted-dialog__message">
      {{ "plans.roadtaxBlacklisted.dialogContent" | translate }}
    </div>
  </div>

  <div class="roadtax-blacklisted-dialog__footer">
    <button mat-stroked-button class="btn--stroke" (click)="closeDialog()">
      {{ "plans.roadtaxBlacklisted.close" | translate }}
    </button>
  </div>
</div>